import { EventEmitter } from "@angular/core";
import { FurnitureModel } from "../../shared/models/furniture.model";
import { ColumnModel } from "../../shared/models/column.model";
export class FurnitureBuildData{
	
    module = {
        name: "Furnitures",
        new_name: "furnitureparts",
        filtered_name:"Furniture",
        has_dot_menu: true,
        icon:'fa-couch',
        permission:'furniture'
    }
    
    onReload: EventEmitter < boolean > = new EventEmitter<boolean>();//Forces Reload of codeblack table on emit.
    rowFunction = (row:FurnitureModel) => {//Generates Row for codeblack-table
        return FurnitureModel.getListRow(row);
    }
    
    columns:ColumnModel[] = [
        {
            title: "Id",
            prop: "id",
            flex_grow: 1,
            row_accessor: "id",
            class:""//force-flex force-flex-end
        },
        {
            title: "Title",
            prop: "title",
            flex_grow: 4,
            row_accessor: "title",
        }
        // {
        //     title: "Email",
        //     prop: "email",
        //     flex_grow: 3,
        //     row_accessor: "email",
        //     class:""//force-flex force-flex-end
        // }
    ];

    constructor(){
        for(let col of this.columns){
            col = new ColumnModel(col);
        }
    }

}